import { useMutation } from '@tanstack/react-query';
import type { GerarLinkTemporarioPayload, GerarLinkTemporarioResponse } from '../types';
import { gerarLinkTemporarioApi } from '../api/GerarLinkTemporarioApi';

export function useGerarLinkTemporario() {
  return useMutation<GerarLinkTemporarioResponse, Error, GerarLinkTemporarioPayload>({
    mutationFn: gerarLinkTemporarioApi,
  });
}
